import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "header-cell"
};
const _hoisted_2 = {
    key: 0,
    class: "actions-column"
};
import _ from "lodash";
import UForm from "@/components/uikit/uComponents/uForm/UForm.vue";
import UProgressBar from "@/components/uikit/uComponents/UProgressBar.vue";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectVotersPage',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const store = useStore();
        // const isDataLoading = computed(() => store.getters["dao/dataLoading"] || store.getters["capitals/dataLoading"]);
        const isDataLoading = ref(false);
        // Заголовки столбцов
        const columns = ["Name", "Apartment", "e-mail", "Tokens"];
        const projectIRI = `/api/au_capitals/${route.params.id}`;
        const items = ref([]);
        const isInvitesSent = ref(false);
        const isReadonly = computed(() => isDataLoading.value || isInvitesSent.value);
        onMounted(async () => {
            isDataLoading.value = true;
            await store.dispatch("dao/getInvites", route.params.id);
            const capital = await store.dispatch("capitals/getAuCapitals", route.params.id);
            isInvitesSent.value = capital.inviteStatus != "draft";
            items.value = store.getters["dao/invites"];
            isDataLoading.value = false;
        });
        function addItem() {
            const newItem = {
                id: Date.now(),
                email: "",
                amount: "",
                name: "",
                apartmentNumber: "",
                auCapital: projectIRI
            };
            items.value.unshift(_.cloneDeep(newItem));
        }
        function removeItem(index) {
            items.value.splice(index, 1);
        }
        function updateItem(index, field, value) {
            const item = items.value[index];
            const expectedType = typeof item[field];
            if (expectedType === "number") {
                item[field] = Number(value);
            }
            else {
                item[field] = value;
            }
        }
        async function Save() {
            isDataLoading.value = true;
            await store.dispatch("dao/createInvites", { id: route.params.id, body: items.value.map(({ id: _, ...rest }) => rest) });
            isDataLoading.value = false;
        }
        async function Invite() {
            await Save();
            isDataLoading.value = true;
            setTimeout(async () => {
                await store.dispatch("dao/sendInvites", route.params.id);
                isInvitesSent.value = true;
            }, 2000);
            isDataLoading.value = false;
            isInvitesSent.value = true;
        }
        function goBack() {
            router.push({ name: "my projects" });
        }
        return (_ctx, _cache) => {
            const _component_UList = _resolveComponent("UList");
            const _component_UButton = _resolveComponent("UButton");
            const _component_UInput = _resolveComponent("UInput");
            return (_openBlock(), _createBlock(UForm, null, {
                header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode(" Voters ", -1)
                    ]))]),
                footerControls: _withCtx(() => [
                    (!isReadonly.value)
                        ? (_openBlock(), _createBlock(_component_UButton, {
                            key: 0,
                            disabled: isDataLoading.value,
                            onClick: Save
                        }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                    _createTextVNode(" Save ", -1)
                                ]))]),
                            _: 1
                        }, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                ]),
                submit: _withCtx(() => [
                    (!isReadonly.value)
                        ? (_openBlock(), _createBlock(_component_UButton, {
                            key: 0,
                            disabled: isDataLoading.value,
                            onClick: Invite
                        }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                    _createTextVNode(" Invite ", -1)
                                ]))]),
                            _: 1
                        }, 8, ["disabled"]))
                        : (_openBlock(), _createBlock(_component_UButton, {
                            key: 1,
                            disabled: isDataLoading.value,
                            onClick: goBack
                        }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                    _createTextVNode(" Back ", -1)
                                ]))]),
                            _: 1
                        }, 8, ["disabled"]))
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_UList, {
                        "flex-direction": "row",
                        gap: "10px"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_UList, {
                                "flex-direction": "row",
                                gap: "5px",
                                class: "flex-1"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column, index) => {
                                        return _createElementVNode("div", {
                                            key: 'header-' + index,
                                            class: "header-cell"
                                        }, _toDisplayString(column), 1);
                                    }), 64)),
                                    (isInvitesSent.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Tokens sent "))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }),
                            (!isReadonly.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createVNode(_component_UButton, {
                                        class: "add-button",
                                        width: "100%",
                                        disabled: isDataLoading.value,
                                        onClick: addItem
                                    }, {
                                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                _createTextVNode(" Add ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["disabled"])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }),
                    (isDataLoading.value)
                        ? (_openBlock(), _createBlock(UProgressBar, {
                            key: 0,
                            green: "",
                            "is-loader": ""
                        }))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, itemIndex) => {
                        return (_openBlock(), _createBlock(_component_UList, {
                            key: item.id,
                            "flex-direction": "row",
                            class: "data-row",
                            gap: "10px"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_UList, {
                                    "flex-direction": "row",
                                    gap: "5px",
                                    class: "flex-1"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_UInput, {
                                            "model-value": item.name,
                                            class: "flex-1",
                                            placeholder: columns[0],
                                            disabled: isReadonly.value,
                                            "onUpdate:modelValue": ($event) => (updateItem(itemIndex, 'name', $event))
                                        }, null, 8, ["model-value", "placeholder", "disabled", "onUpdate:modelValue"]),
                                        _createVNode(_component_UInput, {
                                            "model-value": item.apartmentNumber,
                                            class: "flex-1",
                                            placeholder: columns[1],
                                            disabled: isReadonly.value,
                                            "onUpdate:modelValue": ($event) => (updateItem(itemIndex, 'apartmentNumber', $event))
                                        }, null, 8, ["model-value", "placeholder", "disabled", "onUpdate:modelValue"]),
                                        _createVNode(_component_UInput, {
                                            "model-value": item.email,
                                            class: "flex-1",
                                            placeholder: columns[2],
                                            disabled: isReadonly.value,
                                            "onUpdate:modelValue": ($event) => (updateItem(itemIndex, 'email', $event))
                                        }, null, 8, ["model-value", "placeholder", "disabled", "onUpdate:modelValue"]),
                                        _createVNode(_component_UInput, {
                                            "model-value": Number(item.amount),
                                            type: "number",
                                            class: "flex-1",
                                            placeholder: columns[3],
                                            disabled: isReadonly.value,
                                            "onUpdate:modelValue": value => updateItem(itemIndex, 'amount', value.toString())
                                        }, null, 8, ["model-value", "placeholder", "disabled", "onUpdate:modelValue"]),
                                        (isInvitesSent.value)
                                            ? (_openBlock(), _createBlock(_component_UInput, {
                                                key: 0,
                                                "model-value": item.isTokensSended ? 'Yes' : 'No',
                                                class: "flex-1",
                                                disabled: isReadonly.value
                                            }, null, 8, ["model-value", "disabled"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1024),
                                (!isReadonly.value)
                                    ? (_openBlock(), _createBlock(_component_UList, {
                                        key: 0,
                                        "flex-direction": "row",
                                        gap: "5px",
                                        class: "actions-column actions-center"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_UButton, {
                                                class: "delete-button",
                                                severity: "danger",
                                                width: "100%",
                                                onClick: ($event) => (removeItem(itemIndex))
                                            }, {
                                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                                        _createTextVNode(" Delete ", -1)
                                                    ]))]),
                                                _: 1
                                            }, 8, ["onClick"])
                                        ]),
                                        _: 2
                                    }, 1024))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 2
                        }, 1024));
                    }), 128))
                ]),
                _: 1
            }));
        };
    }
});
